import React, { useMemo } from 'react'
// @ts-ignore no types
import { connect } from 'react-redux'
import { useApplicationContext } from '@adc/ui-adc'
import type { FeatureFlags } from '@adc/ui-adc'
import type { primitives } from '@adc/blueprint'
import * as graph from '@adc/sdk'
import { useListingContext } from '../../../context/listing'
import SectionPanel from '../../../components/sectionPanel'
import RegistrationBanner from '../../../components/registrationBanner'

interface MessageBannerProps {
  pageBannerRef?: any
  featureFlags: FeatureFlags
}

const MessageBanner = ({ pageBannerRef, featureFlags }: MessageBannerProps) => {
  const { listing, segment } = useListingContext()
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { user: untypedUser } = useApplicationContext()
  const user = untypedUser as primitives.AuctionUser

  const authenticateUser = user.logged_in ? user : null

  const shouldShowSealedBidTreatment = useMemo(() => {
    // TODO: shouldShowSealedBidTreatment type should match the ui-adc FeatureFlags type so we wouldn't need to cast this, maybe that type needs to be in constants?
    return segment?.__methods__?.shouldShowSealedBidTreatment(
      featureFlags as Record<string, boolean>
    )
  }, [featureFlags, segment?.__methods__])

  return (
    <SectionPanel elmId='messages' compact>
      <div ref={pageBannerRef} />
      <RegistrationBanner
        isUserAuthenticated={user.logged_in}
        isUserConfirmed={
          authenticateUser?.status === graph.enums.UserStatus.Confirmed
        }
        isUserRegisteredForAuction={
          listing.is_current_user_registered_for_online_auction
        }
        email={authenticateUser?.email}
        shouldShowSealedBidTreatment={shouldShowSealedBidTreatment}
      />
    </SectionPanel>
  )
}
const mapStateToProps = (store: any) => ({
  featureFlags: store.featureFlags,
})

export default connect(mapStateToProps, null)(MessageBanner)
